import { render, staticRenderFns } from "./DTComponent.vue?vue&type=template&id=31868f96&scoped=true&"
import script from "./DTComponent.vue?vue&type=script&lang=js&"
export * from "./DTComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31868f96",
  null
  
)

export default component.exports